"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibraryPlacement = void 0;
var LibraryPlacement;
(function (LibraryPlacement) {
    LibraryPlacement["Library"] = "library";
    LibraryPlacement["LibraryArchive"] = "library_archive";
    LibraryPlacement["LibraryReadingLists"] = "library_reading_lists";
})(LibraryPlacement = exports.LibraryPlacement || (exports.LibraryPlacement = {}));
